/**
 * Shared field mapper for the activity-location draft body. `commonLocationFields`
 * spells out the address + geo + meeting-url block once so the activity-location
 * create/update service helpers (activityLocations.service) stay in sync.
 *
 * Guard rule: address/geo fields are kept iff not `undefined` (an empty string
 * still clears a stored value on update/booking; the caller input types never
 * carry `null`). `meetingUrl` is the exception: an empty BYO url means "no url",
 * so it is dropped, letting the backend return the localized `[ONLINE_URL]` error
 * instead of a generic Zod "invalid url" rejection.
 */
interface CommonLocationInput {
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  latitude?: number;
  longitude?: number;
  radius?: number;
  meetingUrl?: string;
}

/** The shared address + geo + meeting-url block, with `undefined` fields dropped. */
export const commonLocationFields = (input: CommonLocationInput): CommonLocationInput => ({
  ...(input.addressLine1 !== undefined ? { addressLine1: input.addressLine1 } : {}),
  ...(input.addressLine2 !== undefined ? { addressLine2: input.addressLine2 } : {}),
  ...(input.city !== undefined ? { city: input.city } : {}),
  ...(input.state !== undefined ? { state: input.state } : {}),
  ...(input.zipCode !== undefined ? { zipCode: input.zipCode } : {}),
  ...(input.country !== undefined ? { country: input.country } : {}),
  ...(input.latitude !== undefined ? { latitude: input.latitude } : {}),
  ...(input.longitude !== undefined ? { longitude: input.longitude } : {}),
  ...(input.radius !== undefined ? { radius: input.radius } : {}),
  ...(input.meetingUrl ? { meetingUrl: input.meetingUrl } : {})
});
